import React, { useState, useEffect} from 'react';
import axios from 'axios';
import moment from 'moment';
import _ from 'underscore';
import setting from '../../config/setting';
import {Button,Input,Select,Radio,Form,DatePicker,Spin,Space,Row,Col,Card,notification,Upload} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import InputMask from "react-input-mask";
import { history } from './../../redux/store';

let i = 1;

const { TextArea } = Input;
const { Option } = Select;
const FormItem = Form.Item;

const NewOrderForm = () => {
    const [form] = Form.useForm();
    const [locationNewA, setlocationNew] = useState('');
    const [bool, setBool] = useState(false);
    const [Res, setRes] = useState([]);
    const [Notes, setNotes] = useState('');
    const [bgScreening, setBgScreening] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [reasons, setSelectReason] = useState('');
    const [reasonValue, setReasonValue] = useState([]);
    const [service_multi_select, setSelectPackage] = useState('');
    const [packageValue, setPackageValue] = useState([]);
    const [loadingLocations, setLoadingLocations] = useState(false);
    const [loadingReasons, setLoadingReasons] = useState(false);
    const [loadingPkgs, setLoadingPkgs] = useState(false);
    const [orderTypes, setOrderTypes] = useState('new_employee')
    const [hasPermission, setHasPermission] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [employeeData, setEmployeeData] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([{}]);
    const [fileInputs, setFileInputs] = useState([0]);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const companyId = localStorage.getItem('customerId');
    const [employees, setEmployees] = useState([{ employeeId: '', legalName: '', jobTitle: '', emailValue: '', phoneValue: '', startDate: '', dateNew: '', emp_ein: '', ssnValue: '', DL: '', }]);

      const handleSessionExpired = () => {
      notification.open({
        message: 'Odoo session expired',
        description: 'Please login again.',
      });
    
      localStorage.clear();
      history.push('/public/sign-in');
    };

    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const updatedEmployees = [...employees];

         updatedEmployees[index][name] = value;

         setEmployees(updatedEmployees);

     };

    useEffect(() => {
        getResPArt(companyId);
        getReasonNames();
        getPackages(companyId);
        form.setFieldsValue({
            company: companyId
        });
    }, []);

    // ---------------EMPLOYEE DATA API START---------------------
    const getEmployee = () => {
        setIsLoading(true);
        i = 1;
        const customerData = JSON.parse(localStorage.getItem('customerData'));

        axios
            .post(setting.serverUrl + '/api/employeeCustomerPortal2', {
                params: {
                    user: localStorage.getItem('myData'),
                    custIdArr: customerData.employee_multi_select,
                    compId: JSON.parse(localStorage.getItem('customerData')).id,
                }
            },{
                withCredentials:true
            })
            .then((response) => {
                setIsLoading(false);
                if (response.status === 200) {
                    response &&
                        response.data &&
                        response.data.length > 0 &&
                        response.data.map((val) => {
                            return {
                                ...val,
                                fullName:
                                    val.first_name && val.last_name
                                        ? val.first_name +
                                        ' ' +
                                        val.last_name
                                        : '',
                                empLocId:
                                    val.emp_location && val.emp_location.length > 0 ? val.emp_location[0] : '',

                                emp_location:
                                    val.emp_location &&
                                        val.emp_location.length > 0 &&
                                        !val.emp_location[1].includes('|') &&
                                        !val.emp_location[1].includes(',')
                                        ? val.emp_location[1]
                                        : val.emp_location[1]?.split('|')[1] || val.emp_location[1]?.split(',')[1],

                                newDOB: val.dob ? val.dob : '',
                                newDOBforExcel: val.dob ? moment(val.dob).format('MM/DD/YYYY') : '',
                                terminationDate:
                                    val.Termination_Date != false
                                        ? moment(val.Termination_Date).format('MM/DD/YYYY')
                                        : '',
                                hireRehireDate: val.Hire_Rehire_Date != false ? val.Hire_Rehire_Date : '',
                                hireRehireDateforExcel: val.Hire_Rehire_Date != false ? moment(val.Hire_Rehire_Date).format('MM/DD/YYYY') : '',
                                newPassport: val.passport != false ? val.passport : '',
                                statusMarital: val.status_p != false ? val.status_p : '',
                                newNationality: val.nationality != false ? val.nationality : '',
                                newSupervisor: val.supervisor != false ? val.supervisor : '',
                                jobTitle: val.Job_Title != false ? val.Job_Title : '',
                                addCompany: val.add_company[1] != false ? val.add_company[1] : '',
                                newDept: val.department != false ? val.department : '',
                                newGender: val.Gender !== false ? val.Gender : '',
                                newEmail: val.email !== false ? val.email : '',
                                newEmpStatus: val.emp_status !== false ? val.emp_status : '',
                                newProgram: val.program !== false ? val.program : '',
                                newEin: val.emp_ein != false ? val.emp_ein : '',
                                newDL: val.DL != false ? val.DL : '',
                                newSSN: val.emp_ssn != false ? val.emp_ssn?.slice(-4) : ''

                            };
                        });

                    setEmployeeData(response.data);
                    setHasPermission(true);
                } else if (response.status === 201) {
                    setErrMsg('Access permission not allowed.');

                } else if (response.status === 202) {
                    setHasPermission(true);
                } else {
                    notification.error({
                        message: 'Failed to retrieve data at the moment. Please try again in a bit.'
                    });
                }
            }).catch((error) => {
                // ✅ Handle session expired
                if (error?.response?.status === 401) {
                    handleSessionExpired();
                    return;
                }
                });
    };
    useEffect(() => {
        getEmployee();
    }, []);

    // ---------------------EMPLOYEE DATA API END -----------------
    function getReasonNames() {
        setLoadingReasons(true);
        setIsLoading(true);
        axios
            .post(setting.serverUrl + '/api/getReasons', {
                params: {
                    email: localStorage.getItem('myData'),
                    user: localStorage.getItem('myData'),
                }
            },{
                withCredentials:true
            })
            .then((response) => {
                if (response && response.status == 200) {
                     const uniqueNames =
                        response &&
                        response.data.reduce((acc, obj) => {
                            if (!acc[obj.reasons_name]) {
                                acc[obj.reasons_name] = obj;
                            }
                            return acc;
                        }, {});
                    const uniqueArrays = Object.values(uniqueNames);
                     setReasonValue(uniqueArrays);
                    setLoadingReasons(false);
                    setIsLoading(false);
                }
            }).catch((error) => {
            // ✅ Handle session expired
            if (error?.response?.status === 401) {
                handleSessionExpired();
                return;
            }
            });
    }
    function getResPArt(custId) {
        setLoadingLocations(true);
        axios
            .post(setting.serverUrl + '/api/Res', {
                params: {
                    email: localStorage.getItem('myData'),
                    user: localStorage.getItem('myData'),
                    id: custId
                }
            },{
                withCredentials:true
            })
            .then((response) => {
                if (response && response.status == 200) {
                    let finalResult = response.data.map((val) => {
                        return {
                            ...val,
                            name:
                                val.name != '' ? (val.name.includes('|') ? val.name.split('|')[1] : val.name) : ''
                        };
                    });

                    setRes(finalResult);
                    setLoadingLocations(false);
                    setBool(true);
                    setHasPermission(true);
                } else if (response.status === 201) {
                    setErrMsg('Access permission not allowed.');
                } else {
                    notification.error({
                        message: 'Failed to retrieve data at the moment. Please try again in a bit.'
                    });
                }
            }).catch((error) => {
            // ✅ Handle session expired
            if (error?.response?.status === 401) {
                handleSessionExpired();
                return;
            }
            });
    }
    const onChangeDate = (index, date, dateString) => {
        const updatedEmployees = [...employees];
        updatedEmployees[index].dateNew = dateString;
        setEmployees(updatedEmployees);
    };

    const onChangeStartDate = (index, date, dateString) => {
        const updatedEmployees = [...employees];
        updatedEmployees[index].startDate = dateString;
        setEmployees(updatedEmployees);
    };

    function locationNew(event) {
        setlocationNew(event);
    }

    const handleEmployeeSelect = (index, employeeId) => {
        setSelectedEmployee(employeeId);
        const selectedEmployeeData = employeeData.find((employee) => employee.id === employeeId);
        let updatedEmployees = [...employees];
        updatedEmployees[index] = {
            employeeId: selectedEmployeeData.id,
            legalName: `${selectedEmployeeData.first_name} ${selectedEmployeeData.last_name}`,
            jobTitle: selectedEmployeeData.Job_Title,
            emailValue: selectedEmployeeData.email,
            phoneValue: selectedEmployeeData.Mobile,
            startDate: selectedEmployeeData.Hire_Rehire_Date ? selectedEmployeeData.Hire_Rehire_Date : null,
            dateNew: selectedEmployeeData.dob ? selectedEmployeeData.dob : null,
            emp_ein: selectedEmployeeData.emp_ein ? selectedEmployeeData.emp_ein : null,
            ssnValue: selectedEmployeeData.emp_ssn ? selectedEmployeeData.emp_ssn : null,
            DL: selectedEmployeeData.DL ? selectedEmployeeData.DL : null,
        };
        setEmployees(updatedEmployees);

        form.setFieldsValue({
            [`legalName-${index}`]: selectedEmployeeData.first_name && selectedEmployeeData.last_name
                ? `${selectedEmployeeData.first_name} ${selectedEmployeeData.last_name}` : '',
            [`jobTitle-${index}`]: selectedEmployeeData.Job_Title || '',
            [`emailValue-${index}`]: selectedEmployeeData.email || '',
            [`phoneValue-${index}`]: selectedEmployeeData.Mobile || '',
            [`startDate-${index}`]: selectedEmployeeData.Hire_Rehire_Date
                ? moment(selectedEmployeeData.Hire_Rehire_Date) : null,
            [`dateNew-${index}`]: selectedEmployeeData.dob
                ? moment(selectedEmployeeData.dob) : null,
            [`emp_ein-${index}`]: selectedEmployeeData.emp_ein || '',
            [`ssnValue-${index}`]: selectedEmployeeData.emp_ssn
                ? `***-**-${selectedEmployeeData.emp_ssn.slice(-4)}` : '',
            [`DL-${index}`]: selectedEmployeeData.DL || ''
        });
    };

    const clearInputField = () => {
        setEmployees([{ employeeId: '', legalName: '', jobTitle: '', emailValue: '', phoneValue: '', startDate: '', dateNew: '', emp_ein: '', ssnValue: '', DL: '' }]);
        setSelectedEmployee('');
        setlocationNew(''); 
        setBgScreening('');
        setNotes('');
        setSelectReason('');
        setSelectPackage('');
        setSelectedFiles([]);
        setFileInputs([0]);
        form.setFieldsValue({
            emailValue: '',
            phoneValue: '',
            jobTitle: '',
            dateNew: null,  
            startDate: null, 
            selectedEmployee: '',
            locationNewA: '',  
            bgScreening: '',
            Notes: '',
            reasonValue: '',
            employees: '',
            service_multi_select: '',
            packageValue: '',
            selectedFiles: null,
            fileInputs: '',
            emp_ein: '',
            ssnValue: '',
            DL: ''
        });


        form.setFieldsValue({
            [`legalName-0`]: '',
            [`jobTitle-0`]: '',
            [`emailValue-0`]: '',
            [`phoneValue-0`]: '',
            [`emp_ein-0`]: '',
            [`DL-0`]: '',
            [`ssnValue-0`]: '',
            [`selectedEmployee-0`]: '',
            [`startDate-0`]: null,
            [`dateNew-0`]: null,
            [`locationNewA-0`]: '',
            [`reasons-0`]: '',
            [`bgScreening-0`]: '',
            [`Notes-0`]: '',
            [`service_multi_select-0`]: '',
            [`packageValue-0`]: ''
        });
    };

    useEffect(() => {
        clearInputField()
    }, [orderTypes]);  
  
    function saveEmployee() {
        const sizeLimit = 500 * 1024 * 1024;
        const filesArray = selectedFiles as File[];
        
        let totalSize = 0;
        for (let file of filesArray) {
            totalSize += file.size;
        }

        // Only ONE file is uploaded and it is too big
        if (filesArray.length === 1 && filesArray[0].size > sizeLimit) {
            notification.error({
                message: 'File Too Large',
                description: 'The uploaded file is too large. Please upload a file smaller than 500 MB.'
            });
            return; 
        }

        // MULTIPLE files are uploaded and the total is too big
        if (filesArray.length > 1 && totalSize > sizeLimit) {
            notification.error({
                message: 'Total Size Exceeded',
                description: `The total size of all combined files exceeds 500 MB. Current total: ${(totalSize / (1024 * 1024)).toFixed(2)} MB.`
            });
            return;
        }

        setIsLoading(true);
        const formdata = new FormData();
        formdata.append('bgScreening', bgScreening);
        formdata.append('locationNewA', locationNewA);
        formdata.append('comNew', companyId);
        formdata.append('reasons', reasons);
        formdata.append('Notes', Notes);
        formdata.append('employees', JSON.stringify(employees));
        formdata.append('service_multi_select', service_multi_select);
        formdata.append('new_employee', orderTypes);

        formdata.append('email', localStorage.getItem('myData'));  
        formdata.append('user', localStorage.getItem('myData'));

        (selectedFiles as File[]).forEach((file) => {
            formdata.append("files[]", file);   
        });

        const headers = {
            'Content-Type': 'multipart/form-data'
        };

        // Make the API call
        axios.post(setting.serverUrl + '/api/saveNewEmployeeInst', formdata, { headers ,withCredentials:true})
            .then((response) => {
                setIsLoading(false);
                if (response && response.status === 200) {
                    const id = response.data?.id;

                if (id) {
                    let customerData = JSON.parse(localStorage.getItem('customerData')) || {};
                    if (!customerData.employee_multi_select) {
                        customerData.employee_multi_select = [];
                    }
                    customerData.employee_multi_select.push(id);
                    localStorage.setItem('customerData', JSON.stringify(customerData));
                }

                // ✅ Reset form & states
                    clearInputField();
                    form.resetFields();
                    setSelectedFiles([]);

                // ✅ Show success message
                notification.success({
                    message: 'Request Sent Successfully!'
                });
            }
        })
            .catch((error) => {
                 if (error?.response?.status === 401) {
                    handleSessionExpired();
                    return;
                }
                setIsLoading(false);
                 notification.error({
                    message: 'Error',
                    description: 'There was an issue saving the employee. Please try again later.'
                });
            })
    }

    function reasonSelection(event, value) {
        setSelectReason(event);
    }

    function getPackages(companyId) {
        setLoadingPkgs(true);
        axios
            .post(setting.serverUrl + '/api/getNewEmpPkg', {
                params: {
                    email: localStorage.getItem('myData'),
                    user: localStorage.getItem('myData'),
                    companyId: companyId
                }
            },{
                withCredentials:true
            })
            .then((response) => {
                 if (response && response.status == 200) {
                    let result = response.data.rows;
                    const uniqueById  = result.reduce((acc, obj) => {
                    if (!acc[obj.id]) {
                        acc[obj.id] = obj;
                    }
                    return acc;
                }, {});
                 const uniqueArray = Object.values(uniqueById); 
                     setPackageValue(uniqueArray);
                     setLoadingPkgs(false);
                }
            }).catch((error) => {
                // ✅ Handle session expired
                if (error?.response?.status === 401) {
                    handleSessionExpired();
                    return;
                }
                });
    }

    const handleFileChange = (fileList, index) => {
          setSelectedFiles(fileList?.map(val => val?.originFileObj));
    };

    const handleAddRow = () => {
        setEmployees([...employees, { employeeId: '', legalName: '', jobTitle: '', emailValue: '', phoneValue: '', startDate: '', dateNew: '', emp_ein: '', ssnValue: '', DL: '', }]);
        form.setFieldsValue({
            [`legalName-${employees?.length}`]: '',
            [`jobTitle-${employees?.length}`]: '',
            [`emailValue-${employees?.length}`]: '',
            [`phoneValue-${employees?.length}`]: '',
            [`emp_ein-${employees?.length}`]: '',
            [`DL-${employees?.length}`]: '',
            [`ssnValue-${employees?.length}`]: '',
            [`startDate-${employees?.length}`]: null,
            [`dateNew-${employees?.length}`]: null,
            [`selectedEmployee-${employees?.length}`]: '',
        });
    };

    const handleUploadChange = (info, index) => {
        let newFileList = [...info.fileList];
        newFileList = newFileList.map(file => {
            if (file.status !== 'removed') {
                file.status = 'done'; 
            }
            return file;
        });

        handleFileChange(newFileList, index);
    };

    const handleRemoveRow = (index) => {
        const newEmployees = employees.filter((_, idx) => idx !== index);
        setEmployees(newEmployees);

        form.setFieldsValue({
            [`legalName-${index}`]: '',
            [`jobTitle-${index}`]: '',
            [`emailValue-${index}`]: '',
            [`phoneValue-${index}`]: '',
            [`emp_ein-${index}`]: '',
            [`DL-${index}`]: '',
            [`ssnValue-${index}`]: '',
            [`startDate-${index}`]: null,
            [`dateNew-${index}`]: null,
            [`selectedEmployee-${index}`]: '',
        });

        newEmployees.forEach((_, idx) => {
            form.setFieldsValue({
                [`legalName-${idx}`]: form.getFieldValue(`legalName-${idx + (idx >= index ? 1 : 0)}`) || '',
                [`jobTitle-${idx}`]: form.getFieldValue(`jobTitle-${idx + (idx >= index ? 1 : 0)}`) || '',
                [`emailValue-${idx}`]: form.getFieldValue(`emailValue-${idx + (idx >= index ? 1 : 0)}`) || '',
                [`phoneValue-${idx}`]: form.getFieldValue(`phoneValue-${idx + (idx >= index ? 1 : 0)}`) || '',
                [`emp_ein-${idx}`]: form.getFieldValue(`emp_ein-${idx + (idx >= index ? 1 : 0)}`) || '',
                [`DL-${idx}`]: form.getFieldValue(`DL-${idx + (idx >= index ? 1 : 0)}`) || '',
                [`ssnValue-${idx}`]: form.getFieldValue(`ssnValue-${idx + (idx >= index ? 1 : 0)}`) || '',
                [`startDate-${idx}`]: form.getFieldValue(`startDate-${idx + (idx >= index ? 1 : 0)}`) || null,
                [`dateNew-${idx}`]: form.getFieldValue(`dateNew-${idx + (idx >= index ? 1 : 0)}`) || null,
                [`selectedEmployee-${idx}`]: form.getFieldValue(`selectedEmployee-${idx + (idx >= index ? 1 : 0)}`) || '',
            });
        });
    };

    return hasPermission && bool ? (
        <div style={{ padding: 20 }}>
            <h5 style={{ textAlign: 'left', color: '#1C3A6A' }}>New Order</h5>

            <Card style={{ background: 'white' }}>
                <Form
                    layout='vertical'
                    onFinish={() => saveEmployee()}
                    form={form}

                >
                    <div style={{ padding: '20px' }}>
                        <div className='row'>

                            <div className="col-md-6">
                                <Form.Item label="Order Type">
                                    <Select
                                        value={orderTypes}
                                        onChange={(value) => setOrderTypes(value)}
                                        loading={loadingLocations}
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Select Order Type"
                                    >
                                        <Option value="new_employee">New Employee</Option>
                                        <Option value="existing_employee">Existing Employee</Option>
                                        <Option value="employee_file_upload">Employee File Upload</Option>
                                    </Select>
                                </Form.Item>
                            </div>

                            <div className='col-md-6'>
                                <FormItem
                                    label='Company Location'
                                    name='locationNewA'
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Please select Company Location',
                                    },
                                    ]}
                                >
                                    <Select
                                        placeholder='Select Location'
                                        onChange={(event) => locationNew(event)}
                                        loading={loadingLocations}
                                        showSearch
                                        optionFilterProp='children'>
                                        {Res.length > 0 &&
                                            Res.map((loc, index) => <Option value={loc.id}>{loc.name}</Option>)}
                                    </Select>
                                </FormItem>
                            </div>
                        {orderTypes !== "employee_file_upload" && (
                            <>
                            <div className='col-md-6'>
                                <FormItem label='Reason' name='reasonValue'>
                                    <Select
                                        placeholder='Select Reason'
                                        onChange={(event, value) => reasonSelection(event, value)}
                                        loading={loadingReasons}
                                        showSearch
                                        optionFilterProp='children'
                                    >
                                        {reasonValue.length > 0 &&
                                            reasonValue.map((key, index) => (
                                                <Option value={key.id}>{key.reasons_name}</Option>
                                            ))}
                                    </Select>
                                </FormItem>
                            </div>

                            <div className='col-md-6'>
                                <FormItem label='Package' name='packageValue'>
                                    <Select
                                        placeholder='Select Package'
                                        showSearch
                                        optionFilterProp='children'
                                        loading={loadingPkgs}
                                        value={service_multi_select}
                                        onChange={(value) => {
                                             setSelectPackage(value);  
                                        }}
                                    >
                                         {packageValue.length > 0 &&
                                            packageValue.map((key, index) =>     
                                            <Option key={key.id} value={key.id}>
                                            {key.product_id_alias && key.product_id_alias.trim() !== ''
                                                ? key.product_id_alias
                                                : key.name}
                                            </Option>)}
                                    </Select>
                                </FormItem>
                            </div>

                            <div className='col-md-6'>
                                <Form.Item label='Background Screening'>
                                    <Radio.Group value={bgScreening} onChange={(e) => setBgScreening(e.target.value)}>
                                        <Radio value="Yes">Yes</Radio>
                                        <Radio value="No">No</Radio>
                                    </Radio.Group>
                                </Form.Item>
                            </div>

                            <div className='col-md-6'>
                                <FormItem label='Notes' name='Notes'>
                                    <TextArea
                                        rows={3}

                                        value={Notes}
                                        style={{ backgroundColor: '#fff' }}
                                        placeholder='Enter Notes '
                                        onChange={(event) => setNotes(event.target.value)}

                                    />
                                </FormItem>
                            </div>
                            </>
                        )}
                        </div>
                        {orderTypes !== "employee_file_upload" && (
                            <>
                        <h5 style={{ textAlign: 'left', color: '#1C3A6A' }}>Employee(s)</h5>

                        {employees.map((employee, index) => (

                            <div className='row' key={index}>

                                <div className='row'
                                    style={{
                                        background: '#fff',  
                                        boxShadow: '0px -4px 6px rgba(10, 10, 10, 0.1), 0px 4px 6px rgba(10, 10, 10, 0.1)',  
                                        marginBottom: '10px',  
                                        padding: '10px'
                                    }}
                                >

                                    <div className='row' style={{ alignItems: 'center', display: 'flex' }}>
                                        <i onClick={() => handleRemoveRow(index)} className="fa fa-times-circle" style={{
                                            fontSize: '20px',
                                            cursor: "pointer",
                                            color: "#1b3969",
                                            marginTop: '-75px',
                                             paddingLeft: '1px'
                                        }}></i>
                                    </div>

                                    {orderTypes === 'new_employee' && (
                                        <div className="col-md-2">
                                            <Form.Item
                                                label="Employee Name"
                                                style={{ marginLeft: '10px' }}
                                                name={`legalName-${index}`}
                                            >

                                                <Input
                                                    style={{ backgroundColor: 'white', color: '#000', marginLeft: 10 }}
                                                    placeholder="Enter Employee Name"
                                                    value={employee.legalName}
                                                    name="legalName"
                                                    onChange={(event) => handleInputChange(index, event)}
                                                />
                                            </Form.Item>
                                        </div>
                                    )}

                                    {orderTypes === 'existing_employee' && (
                                        <div className="col-md-2">
                                            <Form.Item
                                                label="Employee Name"
                                                style={{ marginLeft: '10px' }}

                                                name={`selectedEmployee-${index}`}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please select an employee!',
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    showSearch
                                                    placeholder="Search and select employee"
                                                    value={selectedEmployee}
                                                    onChange={(value) => handleEmployeeSelect(index, value)}
                                                    filterOption={(input, option) =>
                                                        (String(option?.children ?? '')).toLowerCase().includes(input.toLowerCase())
                                                    }
                                               
                                                >
                                                    {employeeData.map((employee) => (
                                                        <Option key={employee.id} value={employee.id}>
                                                            {employee.first_name + ' ' + employee.last_name}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    )}

                                    <div className="col-md-2" key={index}>
                                        <FormItem
                                            label="EIN"
                                            name={`emp_ein-${index}`}
                                        >
                                            <Input
                                                style={{ backgroundColor: 'white', color: '#000' }}
                                                placeholder="Enter EIN"
                                                onChange={(event) => handleInputChange(index, event)}
                                                value={employee.emp_ein}
                                                name='emp_ein'
                                                disabled={!!selectedEmployee}
                                            />
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                       <Form.Item
                                        label="SSN"
                                        name={`ssnValue-${index}`}
                                        >
                                        <InputMask
                                            mask="999-99-9999"
                                            value={employees[index].ssnValue}
                                            onChange={(event) => handleInputChange(index, event)}
                                            disabled={!!selectedEmployee}
                                        >
                                            {(inputProps: any) => (
                                            <Input
                                                {...inputProps}
                                                style={{ backgroundColor: "white", color: "#000" }}
                                                placeholder="Enter SSN ___-__-____"
                                                name="ssnValue"
                                            />
                                            )}
                                        </InputMask>
                                        </Form.Item>
                                    </div>

                                    <div className='col-md-2'>
                                        <FormItem
                                            label="DL"
                                            name={`DL-${index}`}>
                                            <Input
                                                style={{ backgroundColor: 'white', color: '#000' }}
                                                placeholder='Enter Driver License'
                                                onChange={(event) => handleInputChange(index, event)}
                                                name='DL'
                                                value={employee.DL}
                                                disabled={!!selectedEmployee}
                                            />
                                        </FormItem>
                                    </div>
                                    <div className="col-md-2">
                                        <Form.Item
                                            label="DOB"
                                            name={`dateNew-${index}`}
                                        >
                                            <DatePicker
                                                style={{ width: '100%', padding: 10, borderRadius: 20, color: '#000' }}
                                                placeholder="Enter date of birth"
                                                onChange={(date, dateString) => onChangeDate(index, date, dateString)}
                                                value={employee.dateNew != "" ? moment(employee.dateNew) : null}
                                                format="YYYY-MM-DD"
                                                disabled={!!selectedEmployee}
                                            />
                                        </Form.Item>
                                    </div>
                                    <div className="col-md-2">
                                        <Form.Item
                                            label="Job Title"
                                            name={`jobTitle-${index}`}
                                        >
                                            <Input
                                                style={{ backgroundColor: 'white', color: '#000' }}
                                                value={employee.jobTitle}
                                                name="jobTitle"
                                                onChange={(event) => handleInputChange(index, event)}
                                                placeholder="Enter Job Title"
                                                disabled={!!selectedEmployee}
                                            />
                                        </Form.Item>
                                    </div>
                                    <div className="col-md-2">
                                        <Form.Item
                                            label="Email"
                                            style={{ marginLeft: '10px' }}
                                            name={`emailValue-${index}`}
                                        >
                                            <Input
                                                style={{ backgroundColor: 'white', color: '#000' }}
                                                value={employee.emailValue}
                                                name="emailValue"
                                                onChange={(event) => handleInputChange(index, event)}
                                                placeholder="Enter Email"
                                                disabled={!!selectedEmployee}
                                            />
                                        </Form.Item>
                                    </div>

                                    <div className="col-md-2">
                                        <Form.Item
                                            label="Phone"
                                            name={`phoneValue-${index}`}
                                        >
                                            <Input
                                                style={{ backgroundColor: 'white', color: '#000' }}
                                                placeholder="Enter Phone"
                                                value={employee.phoneValue}
                                                name="phoneValue"
                                                onChange={(event) => handleInputChange(index, event)}
                                                disabled={!!selectedEmployee}
                                            />
                                        </Form.Item>
                                    </div>
                                    <div className="col-md-2">
                                        {orderTypes === 'new_employee' && (
                                            <Form.Item
                                                label="Start Date"
                                                name={`startDate-${index}`}
                                            >
                                                <DatePicker
                                                    style={{ width: '100%', padding: 10, borderRadius: 20, color: '#000' }}
                                                    placeholder="Enter Start Date"
                                                    onChange={(date, dateString) => onChangeStartDate(index, date, dateString)}
                                                    value={employee.startDate ? moment(employee.startDate, 'YYYY-MM-DD') : null}
                                                    format="YYYY-MM-DD"
                                                    disabled={!!selectedEmployee}
                                                />
                                            </Form.Item>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}

                        <Button type='primary' style={{ backgroundColor: '#1b3969' }} className='mt-4' onClick={handleAddRow}>
                            + Add Employee
                        </Button> 
                        </>
                        )}
                        <div>
                            <style>
                        {`
                            .white-delete-btn .ant-upload-list-item .anticon-delete {
                                color: white !important;
                            }

                            .white-delete-btn .ant-upload-list-item-card-actions button {
                                color: white !important;
                            }
                            
                            .white-delete-btn .ant-upload-list-item-action:hover .anticon-delete {
                                color: white !important;
                                opacity: 0.8;
                            }
                        `}
                    </style>
                            <div className="white-delete-btn">

                                <h5 style={{ textAlign: 'left', color: '#1C3A6A' }}>Add Attachments File </h5>

                                {fileInputs.map((input, index) => (
                                    <Form.Item label="Select File (File size must not exceed 500 MB.)" name={`selectedFiles_${index}`} key={index}>   
                                        <div className="row">
                                            <div className="col-xs-3">
                                                <Upload
                                                    key={orderTypes}
                                                    listType="picture"
                                                    beforeUpload={() => false}
                                                    accept="image/jpeg, image/png, image/gif, application/pdf, .xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .zip, application/zip, application/x-zip-compressed"
                                                    onChange={(info) => handleUploadChange(info, index)}
                                                >
                                                    <Button style={{ backgroundColor: '#1b3969' }} type="primary" icon={<UploadOutlined />}>
                                                        Upload
                                                    </Button>
                                                </Upload>
                                            </div>
                                        </div>
                                    </Form.Item>
                                ))}
                            </div>

                            <Button
                                type='primary'
                                style={{ backgroundColor: '#1b3969' }}
                                htmlType={'submit'}
                                className='mt-4'
                            >
                                Submit
                            </Button>

                            {isLoading && (
                                <Space size='middle' style={{ marginTop: 10, marginLeft: 10 }}>
                                    <Spin size='large' />
                                </Space>
                            )}
                        </div>

                    </div>

                </Form>
            </Card>
        </div>
    ) : (
        <div>
            {errMsg.length > 0 ? (
                <p style={{ fontSize: 18, fontWeight: 700, padding: 20, color: 'red' }}>
                    &nbsp;&nbsp; {errMsg}
                </p>
            ) : (
                <Row>
                    <Col span={10}></Col>
                    <Col span={8}>
                        <Space size='middle' style={{ marginTop: 50 }}>
                            <Spin size='large' />
                        </Space>
                    </Col>
                </Row>
            )}
        </div>
    );
};

export default NewOrderForm;